import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EnodeVehicle, Intervention } from 'src/app/services/enode/enode.types';
import { marked } from 'marked';

@Component({
  selector: 'app-intervention-modal',
  templateUrl: './intervention-modal.component.html',
  styleUrls: ['./intervention-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InterventionModalComponent {
  @Input('vehicle') vehicle: EnodeVehicle;
  @Input('interventions') interventions: Intervention[];

  constructor(private modalCtrl: ModalController) { }

  parseIntervention(intervention: Intervention) {
      // Improve markeds rendering of lists
      const data = intervention.resolution.description
          // remove br tags to enable marked to render lists
          .replace(/<br>/g, '\n')
          // add tabs to litsts to render them as sublists
          .replace(/ -/g, '     -')

      const html = (marked.parse(data) as string)
      .replace(/<ul>/g, '<ul class="text-left">')
      .replace(/<ol>/g, '<ol class="text-left">')
      .replace(/<li>/g, '<li class="my-2 ">');

      return html;

  }

  cancel() {
      this.modalCtrl.dismiss();
  }
}